<template>
    <div class="log-list">
        <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
            <el-form-item>
                <el-form-item label="所属工作类别">
                    <el-select v-model="filter.firstCateId" placeholder="请选择" :clearable="true">
                        <el-option v-for="item in firstCates" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="filter.secondCateId" placeholder="请选择" :clearable="true">
                        <el-option v-for="item in secondCates" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-button-group>
                        <el-button type="primary" @click="fetch(1)" size="mini">筛选</el-button>
                    </el-button-group>
                </el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="add" size="mini">新增</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-dialog :title="form.id ? '修改专业技能' : '新增专业技能'" @close="closeDialog" :visible.sync="dialogFormVisible">
            <el-form ref="cateInfo" :model="form" :rules="rules" size="mini" label-width="140px">
                <el-form-item label="所属工作类别" prop="parentId">
                    <el-select v-model="form.parentId" placeholder="请选择">
                        <el-option v-for="item in firstCates" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="技能名称" prop="name">
                    <el-input size="medium" style="width:170px" v-model.trim="form.name"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="priority">
                    <el-input v-model.number.trim="form.priority"></el-input>
                </el-form-item>
                <el-form-item label="类目图片" prop="image">
                    <el-upload action="https://up-z1.qbox.me/" :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUpload" :data="uploadData">
                        <img v-if="form.image" :src="form.image" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <el-input type="hidden" v-model="form.image"></el-input>
                    </el-upload>
                    <p>图片比例为1:1</p>
                </el-form-item>
                <el-form-item v-if="form.id">
                    <el-button v-if="!showCateConfig" type="text" @click="showCateConfig = true">修改类目配置</el-button>
                    <el-button v-else type="text" @click="showCateConfig = false">不修改类目配置</el-button>
                </el-form-item>
                <template v-if="showCateConfig">
                    <el-form-item label="认证人才数" prop="certPersonnel">
                        <el-input v-model.number.trim="form.certPersonnel"></el-input>
                    </el-form-item>
                    <el-form-item label="服务企业数" prop="enterprisesNum">
                        <el-input v-model.number.trim="form.enterprisesNum"></el-input>
                    </el-form-item>
                    <el-form-item label="累计工作小时数" prop="workingHours">
                        <el-input v-model.number.trim="form.workingHours"></el-input>
                    </el-form-item>
                    <el-form-item label="文章id" prop="articles">
                        <el-input type="textarea" rows="5" v-model.trim="form.articles"></el-input>
                        <p>多个用户id使用“#”分割</p>
                    </el-form-item>
                </template>
                <el-form-item v-if="form.id">
                    <el-button v-if="!showCateTip" type="text" @click="showCateTip = true">修改微服务提示语</el-button>
                    <el-button v-else type="text" @click="showCateTip = false">不修改微服务提示语</el-button>
                </el-form-item>
                <template v-if="showCateTip">
                    <el-form-item label="标题提示语">
                        <el-input type="textarea" :rows="5" :maxlength="300" v-model="form.serviceTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="内容提示语">
                        <el-input type="textarea" :rows="5" :maxlength="300" v-model="form.serviceContent"></el-input>
                    </el-form-item>
                    <el-form-item label="交付物提示语">
                        <el-input type="textarea" :rows="5" :maxlength="300" v-model="form.serviceDeliver"></el-input>
                    </el-form-item>
                    <el-form-item v-for="deliverable,key in deliverConfig" :label="`交付物${key+1}`" :key="key">
                        <el-input type="text" v-model="deliverable.name" :maxlength="20" placeholder="标题，最多20个字"></el-input>
                        <el-input type="text" v-model="deliverable.describe" :maxlength="50" placeholder="描述，最多50个字"></el-input>
                    </el-form-item>
                    <el-form-item v-if="deliverConfig.length < 10">
                        <el-button type="text" @click="addDeliverable">添加交付物</el-button>
                    </el-form-item>
                </template>
            </el-form>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetDialogForm">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>
        <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column prop="id" label="序号" sortable width="80">
            </el-table-column>
            <el-table-column prop="parentName" label="上级类目">
            </el-table-column>
            <el-table-column prop="name" label="类目名称">
            </el-table-column>
            <el-table-column prop="priority" label="排序" width="80">
            </el-table-column>
            <el-table-column v-if="false" prop="solutions" label="解决方案id">
                <template slot-scope="scope">
                    <div v-html="formatSolutions(scope.row.solutions)"></div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">修改
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleBan(scope.$index, scope.row,false)" v-if="scope.row.status == 1">禁用
                        </el-button>
                        <el-button size="mini" type="success" @click="handleBan(scope.$index, scope.row,true)" v-if="scope.row.status == 0">启用
                        </el-button>
                        <el-button size="mini" type="success" @click="showInCategory(scope.row,1)" v-if="scope.row.categoryShow == 0" :disabled="scope.row.status == 0">类目页展示</el-button>
                        <el-button size="mini" type="danger" @click="showInCategory(scope.row,0)" v-if="scope.row.categoryShow == 1" :disabled="scope.row.status == 0">取消类目页展示</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="i=>pageNum=i" :page-size="limit" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import api from "../api";

const { workCateList, cate } = api;
export default {
  name: "workCate-list",
  data() {
    return {
      loading: true,
      tableData: [],
      options: [],
      cates: [],
      filter: {
        firstCateId: "",
        secondCateId: "",
      },
      form: {
        id: "",
        parentId: "",
        name: "",
        priority: 0,
        certPersonnel: "",
        enterprisesNum: "",
        workingHours: "",
        image: "",
        articles: "",
        serviceTitle: "",
        serviceContent: "",
        serviceDeliver: "",
      },
      deliverConfig: [
        {
          name: "",
          describe: "",
        },
      ],
      dialogFormVisible: false,
      roles: [],
      total: 0,
      pageNum: 1,
      limit: 20,
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },
      showCateConfig: false,
      showCateTip: false,
      rules: {
        parentId: [
          {
            required: true,
            message: "请选择所属工作类别",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入技能名称",
            trigger: "blur",
          },
        ],
        priority: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
          {
            type: "number",
            message: "请输入正确的数字",
            trigger: "blur",
          },
        ],
        certPersonnel: [
          {
            required: true,
            message: "请输入认证人才数",
            trigger: "blur",
          },
          {
            type: "number",
            message: "请输入正确的数字",
            trigger: "blur",
          },
        ],
        enterprisesNum: [
          {
            required: true,
            message: "请输入服务企业数",
            trigger: "blur",
          },
          {
            type: "number",
            message: "请输入正确的数字",
            trigger: "blur",
          },
        ],
        workingHours: [
          {
            required: true,
            message: "请输入累计工作小时数",
            trigger: "blur",
          },
          {
            type: "number",
            message: "请输入正确的数字",
            trigger: "blur",
          },
        ],
        image: [
          {
            required: true,
            message: "请上传类目图片",
            trigger: "blur",
          },
        ],
        articles: [
          {
            required: true,
            message: "请输入文章id",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    firstCates() {
      return this.getCatesById(0);
    },
    secondCates() {
      return this.getCatesById(this.filter.firstCateId);
    },
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  methods: {
    async getAllTags() {
      let {
        data: { code, data },
      } = await api.workCateList.getAllTags();
      if (code == 200) {
        this.cates = data.workCategory;
      }
    },
    getCatesById(id) {
      let arr = [];
      this.cates.forEach((item) => {
        if (item.parentId === id) {
          arr.push(item);
        }
      });
      return arr;
    },
    async getToken() {
      let res = await api.upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    formatSolutions(arr) {
      let str = "";
      if (arr.length > 0) {
        arr.forEach((item, key) => {
          if (key == arr.length - 1) {
            str += `${item}`;
          } else {
            str += `${item}、<br>`;
          }
        });
      }
      return str;
    },
    async getWorkList() {
      let resSelect = await workCateList.list();
      this.options = resSelect.data.data;
    },
    async fetch(num) {
      this.loading = true;
      if (num == 1) {
        this.pageNum = 1;
      }
      let parentId = this.filter.secondCateId || this.filter.firstCateId;
      let res = await workCateList.getSkillList({
        pageNum: this.pageNum,
        limit: this.limit,
        parentId: parentId,
      });
      this.total = res.data.pageinfo.totalCount;
      this.tableData = res.data.data;
      this.loading = false;
    },
    async add(index, row) {
      this.dialogFormVisible = true;
      this.form.name = "";
      this.form.id = "";
      this.form.parentId = "";
      this.form.priority = 0;
      this.form.image =
        "https://image.duiyou360.com/FujuDq_7xRaOTjauJ_o1ww5JSFWI";
    },
    async handleEdit(index, row) {
      let obj = {
        categoryId: row.id,
      };
      let {
        data: { code, data },
      } = await cate.detail(obj);
      if (code == 200) {
        this.dialogFormVisible = true;
        data.image =
          data.image ||
          "https://image.duiyou360.com/FujuDq_7xRaOTjauJ_o1ww5JSFWI";
        this.form = data;
        this.form.articles =
          data.articles && data.articles.length > 0
            ? data.articles.join("#")
            : "";
        this.form.image = data.image;
        this.deliverConfig = data.deliverConfig || [];
      }
    },
    async handleBan(index, row, ifDelete) {
      let status = "";
      if (ifDelete) {
        status = "1";
      } else {
        status = "0";
      }
      let {
        data: { code },
      } = await workCateList.updateStatus({
        id: row.id,
        status: status,
      });
      if (code === 200) {
        this.fetch();
      }
    },
    submit() {
      this.$refs.cateInfo.validate((valid) => {
        if (valid) {
          this.saveCate();
        } else {
          return false;
        }
      });
    },
    formatDeliverables() {
      let arr = this.deliverConfig;
      let newArr = [];
      arr.forEach((item) => {
        if (item.name && item.describe) newArr.push(item);
      });
      return newArr;
    },
    async saveCate() {
      console.log(this.deliverConfig);

      let {
        id,
        name,
        parentId,
        priority,
        certPersonnel,
        enterprisesNum,
        workingHours,
        image,
        articles,
        serviceTitle,
        serviceContent,
        serviceDeliver,
      } = this.form;
      let obj = {
        id,
        name,
        parentId,
        priority,
        image,
      };
      if (this.showCateConfig) {
        let artArr = articles.split("#");
        let newArtArr = [];
        artArr.forEach((item) => {
          if (item.length) newArtArr.push(item);
        });
        obj.certPersonnel = certPersonnel;
        obj.enterprisesNum = enterprisesNum;
        obj.workingHours = workingHours;
        obj.articles = newArtArr;
      }

      // if (this.showCateTip) {
      obj.serviceTitle = serviceTitle;
      obj.serviceContent = serviceContent;
      obj.serviceDeliver = serviceDeliver;
      obj.deliverConfig = this.formatDeliverables();
      // }
      let {
        data: { code },
      } = await workCateList.save(obj);
      if (code === 200) {
        this.showCateConfig = false;
        if (this.form.id != "") {
          this.$message.success("修改成功");
        } else {
          this.$message.success("增加技能成功");
        }
        this.resetDialogForm();
      }
      this.fetch();
    },
    closeDialog() {
      this.showCateConfig = false;
      this.$refs.cateInfo.resetFields();
    },
    resetDialogForm() {
      this.dialogFormVisible = false;
    },
    async showInCategory(data, isShow) {
      // 切换在首页和类目页展示状态
      let obj = {
        id: data.id,
        categoryShow: isShow,
      };
      let {
        data: { code },
      } = await cate.showInCategory(obj);
      if (code == 200) {
        this.fetch();
      }
    },
    handleSuccess(res, file) {
      this.form.image = `https:\/\/image.duiyou360.com/${res.key}`;
    },
    beforeUpload(file) {
      let sizeM = file.size / 1024 / 1024;
      this.chunks = Math.ceil(sizeM / 10); // 大于10m文件进行分片
      this.uploadData.name = file.name;
    },
    addDeliverable() {
      this.deliverConfig.push({
        name: "",
        describe: "",
      });
    },
  },
  mounted() {
    this.getAllTags();
    // this.getWorkList();
    this.fetch();
    this.getToken();
  },
};
</script>
<style>
.avatar {
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #ffffff;
  font-size: 20px;
}

.el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar-idCard {
  width: 100px;
  height: 100px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/cate/skills.vue